import PropTypes from 'prop-types'
import { Box } from '@mui/material'

const BoxBreadcrumbs = (props) => <Box display="flex" alignItems="center" justifyContent="space-between" {...props} />

BoxBreadcrumbs.propTypes = {
  children: PropTypes.node.isRequired,
}

export default BoxBreadcrumbs
